export default __webpack_public_path__ + "static/media/iPet.b7b73fd7.png";